<template>
  <v-app id="app" >
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>
